// extracted by css-extract-rspack-plugin
export default {"wrapper":"jq7Ro","formatting":"uqffJ","error":"lDviO","toolbar":"O_ZFJ","toolbarButton":"wZ6Td","editor":"tf32G","tooltips":"ZhLd5","shortcuts":"wsqS_"};